skrilla.controller('chargeBackDepositModalCtrl', function ($scope, searchService, modalService, cacheService, currencyService, validationService) {
    $scope.validate = {};
    $scope.deposit = cacheService.getObjectOrElse("depositDetails", modalService.dismissAll);
    $scope.request = {
        fee: 35
    };

    $scope.chargeBack = function(){
        if(validate()) {
            modalService.confirm("Are you sure you'd like to charge back this deposit?", function () {
                let request = {
                    ...$scope.request,
                    fee: currencyService.multiply($scope.request.fee, $scope.deposit.currency)
                }
                searchService.post(`deposits/${$scope.deposit.id}/chargeBack`, request, "Deposit successfully charged back", true)
                    .then(modalService.dismissAll);
            })
        }
    }

    function validate(){
        let inputs = [
            validationService.buildFieldValidationObj("fee", !isNaN($scope.request.fee) && validationService.isNotEmpty($scope.request.fee), "Please enter a valid fee"),
            validationService.buildFieldValidationObj("reference", validationService.isNotEmpty($scope.request.reference), "Please enter a valid reference")
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});